import React from 'react'

import Icon, { IconName } from 'components/Icon'
import theme from 'theme'

enum AttackIconNames {
  blackhole = 'blackhole',
  cpu = 'cpu',
  gpu = 'gpu',
  disk = 'disk',
  dns = 'dns',
  io = 'io',
  latency = 'latency',
  memory = 'memory',
  packet_loss = 'packet_loss',
  process_killer = 'process_killer',
  shutdown = 'shutdown',
  time_travel = 'time_travel',
  status_check = 'status_check',
  collect_certs = 'collect_certs',
  process_exhaustion = 'process_exhaustion'
}

export const AttackTypeIcon: React.FC<{
  className?: string
  color?: string
  icon?: IconName | 'fallback'
}> = ({
  className = '',
  color = theme.colors.gray[1],
  icon = 'fallback',
  ...rest
}) => {
  const objectKey = icon.replace('--', '').toLowerCase()

  const iconName: IconName = AttackIconNames[objectKey] ?? 'time_travel'

  return (
    <Icon
      className={className}
      css={{
        fontSize: theme.fontSizes[4],
        color
      }}
      icon={iconName}
      {...rest}
    />
  )
}
